var map = {
	"./starwars-8-les-derniers-jedi-00.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-00.webp",
	"./starwars-8-les-derniers-jedi-01.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-01.webp",
	"./starwars-8-les-derniers-jedi-02.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-02.webp",
	"./starwars-8-les-derniers-jedi-03.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-03.webp",
	"./starwars-8-les-derniers-jedi-04.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-04.webp",
	"./starwars-8-les-derniers-jedi-05.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-05.webp",
	"./starwars-8-les-derniers-jedi-06.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-06.webp",
	"./starwars-8-les-derniers-jedi-07.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-07.webp",
	"./starwars-8-les-derniers-jedi-08.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-08.webp",
	"./starwars-8-les-derniers-jedi-09.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-09.webp",
	"./starwars-8-les-derniers-jedi-10.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-10.webp",
	"./starwars-8-les-derniers-jedi-11.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-11.webp",
	"./starwars-8-les-derniers-jedi-12.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-12.webp",
	"./starwars-8-les-derniers-jedi-13.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-13.webp",
	"./starwars-8-les-derniers-jedi-14.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-14.webp",
	"./starwars-8-les-derniers-jedi-15.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-15.webp",
	"./starwars-8-les-derniers-jedi-20.webp": "./src/assets/images/origins/star-wars-8-les-derniers-jedi/starwars-8-les-derniers-jedi-20.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/origins/star-wars-8-les-derniers-jedi sync ^\\.\\/.*$";